export const headerData = [
  // {
  //   type: "checkbox",
  //   text: ""
  // },
  {
    text: "Name",
  },
  {
    text: "Type",
  },
  {
    text: "Status",
  },
];

export const footerData = {
  title: "No zonalConfig yet",
  subTtitle: "Try the blue button on the top right and add a few!",
  imgSrc: "../../../assets/images/no-search-icon.svg",
  alt: "no search found",
};

export const bodyDataAndKeyTypes = [
  {
    key: "zoneName",
    type: "",
  },
  {
    key: "type",
    type: "",
  },
  {
    key: "status",
    type: "",
  },
];

export const zonalConfigProductHeaderData = [
  {
    text: "",
  },
  {
    text: "Items",
  },
  {
    text: "Price",
  },
];

export const zonalConfigProductBodyDataAndKeyTypes = [
  // {
  //   key: "isChecked",
  //   type: "checkbox",
  //   prepend: "",
  // },
  {
    key: "itemName",
    type: "",
    prepend: "",
  },
  {
    key: "itemAvailable",
    type: "",
    prepend: "",
  },
];

export const zonalConfigBasketProductBodyDataAndKeyTypes = [
  {
    key: "isChecked",
    type: "checkbox",
    prepend: "",
  },
  {
    key: "itemName",
    type: "",
    prepend: "",
  },
];

export const zonalConfigProductFooterData = {
  title: "No record found",
  subTtitle: "No such order exists. Create one?",
  imgSrc: "../../../assets/images/no-search-icon.svg",
  alt: "no search found",
};
